import { ChevronDown } from 'lucide-react';
import FileTree from '../FileTree';
import type { FileTreeNode } from '../../types/wizard';

interface FileExplorerProps {
  fileTree: FileTreeNode[];
  selectedPath: string | null;
  onSelectFile: (path: string) => void;
  projectName: string;
}

export default function FileExplorer({
  fileTree,
  selectedPath,
  onSelectFile,
  projectName,
}: FileExplorerProps) {
  return (
    <div className="flex flex-col h-full bg-[#1e1e1e] border-r border-dark-border overflow-hidden">
      <div className="flex items-center justify-between px-4 py-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
        Explorer
      </div>

      <div className="flex items-center gap-1 px-4 py-1.5 text-xs font-semibold text-gray-300">
        <ChevronDown className="h-3 w-3" />
        {projectName}
      </div>

      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <FileTree
          nodes={fileTree}
          selectedPath={selectedPath ?? undefined}
          onSelect={onSelectFile}
        />
      </div>
    </div>
  );
}
